import 'whatwg-fetch'
const NETWORK_TIMEOUT = 'NETWORK_TIMEOUT'
const NETWORK_ERROR = 1006
const NO_AUTH = 1005
const NO_EXIST = 1007
let API_SERVER = ''

// if(process.env.NODE_ENV == 'development'){
//     API_SERVER = 'http://test-kpp.qiyi.domain'
// }else{
//     API_SERVER = 'http://api-kpp.if.iqyi.com'
// }

function handleUrl(url,options) {
   let urlStr = []
   for(let key of Object.keys(options)){
       urlStr.push(`${key}=${options[key]}`)
   }
   return url+'?'+urlStr.join('&')
}

function timeoutPromise(){
  return new Promise((resolve, reject) => {
      setTimeout(() => {
              resolve(NETWORK_TIMEOUT)
          }, 10000)
      }
  )
}

async function getTimeout(url,options={},headers = {}) {
  let value = await Promise.race([timeoutPromise(),get(url,options,headers)])
  if(!!value && value == NETWORK_TIMEOUT){
    return NETWORK_ERROR
  }
  return value
}

async function postTimeout(url,options={},headers = {}) {
  let value = await Promise.race([timeoutPromise(),post(url,options,headers)])
  if(!!value && value == NETWORK_TIMEOUT){
    return NETWORK_ERROR
  }
  return value
}

async function get(url,options={}, headers = {}) {
    let getUrl
    if(!!Object.keys(options).length){
        getUrl = handleUrl(url,options)
    }else{
        getUrl = url
    }
    getUrl = API_SERVER + getUrl
    try{
      const tmpHeaders = Object.assign({
        'dfp':'',
      }, headers)

      let response = await fetch(getUrl,{
           headers: tmpHeaders,
           method:'get',
           mode: "cors",
      })
      let responseJson = await response.json()
      if(responseJson.resultCode === 'A00000'){
        return responseJson.data
      }
      if(responseJson.resultCode === 'A00002'){
        return NO_AUTH
      }
      if(responseJson.resultCode == 'B001006' || responseJson.resultCode == 'B001007' || responseJson.resultCode == 'B001008'){
        return NO_EXIST
      }
    }catch(error){
        return NETWORK_ERROR
    }
}

async function post(url,options,headers) {
     let getUrl = API_SERVER + url
     try{
         let response = await fetch(getUrl, {
           body: JSON.stringify(options),
           headers:{
             'Content-Type': 'application/json',
             ...headers
           },
           method: 'POST',
         })
         let responseJson = await response.json()
         if(responseJson.resultCode === 'A00000'){
           return responseJson.data
         }
         if(responseJson.resultCode === 'A00002'){
          return NO_AUTH
         }
         if(responseJson.resultCode == 'B001006' || responseJson.resultCode == 'B001007' || responseJson.resultCode == 'B001008'){
          return NO_EXIST
        }
     }catch(error){
        // console.log('网络出问题了',error)
        return NETWORK_ERROR
     }

}

export {
    getTimeout,
    get,
    post,
    postTimeout
}



// WEBPACK FOOTER //
// ./src/common/util/fetch.js